import { render, staticRenderFns } from "./AssignUserTags.vue?vue&type=template&id=60f91fa2&scoped=true"
import script from "./AssignUserTags.vue?vue&type=script&lang=js"
export * from "./AssignUserTags.vue?vue&type=script&lang=js"
import style0 from "./AssignUserTags.vue?vue&type=style&index=0&id=60f91fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f91fa2",
  null
  
)

export default component.exports